module.exports = __webpack_public_path__ + "img/1.41dc22b4.png";